var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricesLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99984 0.666992C4.40335 0.666992 0.666504 4.40383 0.666504 9.00033C0.666504 13.5968 4.40335 17.3337 8.99984 17.3337C13.5963 17.3337 17.3332 13.5968 17.3332 9.00033C17.3332 4.40383 13.5963 0.666992 8.99984 0.666992ZM13.6665 9.7898H12.4033L11.1753 12.2459C11.0174 12.5091 10.7542 12.6845 10.456 12.6845C10.1577 12.6845 9.87703 12.5091 9.75422 12.2459L7.5437 7.87752L6.80686 9.3512C6.6665 9.61436 6.40335 9.7898 6.1051 9.7898H4.35071C3.91212 9.7898 3.56124 9.43892 3.56124 9.00033C3.56124 8.56173 3.91212 8.21085 4.35071 8.21085H5.61387L6.84194 5.75471C7.1051 5.2284 7.98229 5.2284 8.24545 5.75471L10.4384 10.1231L11.1928 8.63191C11.3332 8.36875 11.5963 8.19331 11.8946 8.19331H13.649C14.0876 8.19331 14.4384 8.54419 14.4384 8.98278C14.4384 9.42138 14.1051 9.7898 13.6665 9.7898Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricesLinkIcon);
export default __webpack_public_path__ + "static/media/prices-link-icon.4016c9b61b4da8768fdd2cda2d465c8f.svg";
export { ForwardRef as ReactComponent };